import React from 'react'
import { DateRangePicker } from 'react-date-range'
import { useNavigate } from 'react-router-dom'
import moment from 'moment'
import {
  $DCprimaryColor,
  PixelBreadcrumbs,
  PixelButton,
  PixelModal,
  PixelPageContainer,
  PixelTable,
  PixelTopBar,
  SectionActions,
} from 'pixel-base'
import queryString from 'query-string'
import styled from 'styled-components'

import { getCourierDeliveryDetails } from 'utils/api-routes.util'

const BoldSpan = styled.div`
  font-weight: 700;
`

const columns = [
  {
    dataKey: 'courier_name',
    name: 'Courier',
    sortable: true,
    selector: (row) => row.courier_name || '--',
  },
  {
    dataKey: 'total_order_shipped',
    name: 'Shipped ',
    sortable: true,
    selector: (row) => row.total_order_shipped || '--',
  },
  {
    dataKey: 'total_orders_returned',
    name: 'Returned',
    sortable: true,
    selector: (row) => row.total_orders_returned || '--',
  },
  {
    dataKey: 'total_return_received',
    name: 'Return Received',
    sortable: true,
    selector: (row) => row.total_return_received || '--',
  },
  {
    dataKey: 'total_orders_delivered',
    name: 'Delivered',
    sortable: true,
    selector: (row) => row.total_orders_delivered || '--',
  },
  {
    dataKey: 'total_orders_inprocess',
    name: 'In Progress',
    sortable: true,
    selector: (row) => row.total_orders_inprocess || '--',
  },
  {
    dataKey: 'Returns_not_received',
    name: (
      <BoldSpan
        className="text-danger"
        title="These orders are not returned physically or no return was received"
      >
        Returns Not Received
      </BoldSpan>
    ),
    sortable: true,
    selector: (row) => row.Returns_not_received || '--',
  },
]

const Dashboard = () => {
  const [deliverySummary, setDeliverySummary] = React.useState([])
  const [tableLoading, setTableLoading] = React.useState(false)
  const [showDateModal, setshowDateModal] = React.useState(false)
  const navigate = useNavigate()
  const p = queryString.parse(window.location.search)

  const [filters, setFilters] = React.useState<any>({
    start_date: p.start_date || moment().startOf('month').format('YYYY-MM-DD'),
    end_date: p.end_date || moment().format('YYYY-MM-DD'),
  })

  const breadcrumbs = [
    {
      name: 'Delivery Performance',
      active: true,
    },
  ]

  React.useEffect(() => {
    navigate({
      pathname: '/payments/delivery-details',
      search: queryString.stringify(filters),
    })
    getAllDeliverySummary()
  }, [filters])
  const getAllDeliverySummary = () => {
    setTableLoading(true)
    getCourierDeliveryDetails(filters).subscribe((res: any) => {
      setDeliverySummary(res.response.data)
      setTableLoading(false)
    })
  }

  return (
    <>
      <PixelTopBar>
        <PixelBreadcrumbs data={breadcrumbs} />
        <SectionActions>
          <PixelButton variant="outline" onClick={() => setshowDateModal(true)}>
            {moment.isMoment(filters.start_date)
              ? moment(filters.start_date).format('YYYY-MM-DD')
              : filters.start_date}{' '}
            {'>'}{' '}
            {moment.isMoment(filters.end_date)
              ? moment(filters.end_date).format('YYYY-MM-DD')
              : filters.end_date}
          </PixelButton>
        </SectionActions>
      </PixelTopBar>
      <PixelPageContainer>
        <PixelTable
          columns={columns}
          data={deliverySummary}
          progressPending={tableLoading}
        />
      </PixelPageContainer>
      {showDateModal && (
        <PixelModal
          title={''}
          size={{
            width: '950px !important',
            maxWidth: '100% !important',
          }}
          handleClose={() => setshowDateModal(false)}
          show={showDateModal}
        >
          <DatepickerContainer>
            <DateRangePicker
              rangeColors={[$DCprimaryColor]}
              onChange={(item) => {
                if (
                  moment(item.selection.startDate).format('YYYY-MM-DD') !==
                  moment(item.selection.endDate).format('YYYY-MM-DD')
                ) {
                  setshowDateModal(false)
                } else if (
                  item.selection.startDate === '' &&
                  item.selection.endDate === ''
                ) {
                  setshowDateModal(false)
                }
                setFilters({
                  start_date: moment(item.selection.startDate).format(
                    'YYYY-MM-DD',
                  ),
                  end_date: moment(item.selection.endDate).format('YYYY-MM-DD'),
                })
              }}
              showSelectionPreview={true}
              moveRangeOnFirstSelection={false}
              months={2}
              ranges={[
                {
                  startDate: new Date(filters.start_date),
                  endDate: new Date(filters.end_date),
                  key: 'selection',
                },
              ]}
              direction="horizontal"
            />
          </DatepickerContainer>
        </PixelModal>
      )}
    </>
  )
}

const DatepickerContainer = styled.div`
  overflow: auto;
`

export default Dashboard
